[
  {
    "id": "dawnmere_orc_attack_battle",
    "commandPointReward": 5,
    "scale": 5,
    "name": "The Attack on Dawnmere",
    "locationId": "dawnmere",
    "briefing": "Orcs are in the lanes already. You have whoever you brought with you and nothing else.",
    "enemyStacks": [
      {
        "unitId": "orc_raiders",
        "count": 20
      },
      {
        "unitId": "orc_berserkers",
        "count": 5
      }
    ],
    "victoryFlags": [
      "dawnmere_orc_attack_repelled"
    ],
    "defeatFlags": [
      "dawnmere_orc_attack_lost"
    ]
  },
  {
    "id": "dawnmere_orc_attack_defended_battle",
    "commandPointReward": 10,
    "scale": 5,
    "name": "The Defended Attack on Dawnmere",
    "locationId": "dawnmere",
    "briefing": "The guard believed you. Infantry hold the lane, crossbows on the roofs.",
    "enemyStacks": [
      {
        "unitId": "orc_raiders",
        "count": 20
      },
      {
        "unitId": "orc_berserkers",
        "count": 4
      }
    ],
    "alliedStacks": [
      {
        "unitId": "kingdom_infantry",
        "count": 24
      },
      {
        "unitId": "human_crossbowmen",
        "count": 14
      }
    ],
    "victoryFlags": [
      "dawnmere_orc_attack_repelled"
    ],
    "defeatFlags": [
      "dawnmere_orc_attack_lost"
    ],
    "lootMoney": 40
  },
  {
    "id": "goldenfields_orc_raid_battle",
    "commandPointReward": 10,
    "scale": 5,
    "name": "The Raid on Goldenfields",
    "locationId": "goldenfields",
    "enemyStacks": [
      {
        "unitId": "orc_raiders",
        "count": 16
      }
    ],
    "victoryFlags": [
      "goldenfields_raid_repelled"
    ],
    "defeatFlags": [
      "goldenfields_raid_lost"
    ],
    "lootMoney": 25,
    "allowRetreat": true,
    "retreatFlags": [
      "goldenfields_destroyed"
    ]
  },
  {
    "id": "goldenfields_orc_raid_defended_battle",
    "commandPointReward": 15,
    "scale": 5,
    "name": "The Defended Raid on Goldenfields",
    "locationId": "goldenfields",
    "enemyStacks": [
      {
        "unitId": "orc_raiders",
        "count": 12
      }
    ],
    "alliedStacks": [
      {
        "unitId": "kingdom_infantry",
        "count": 16
      }
    ],
    "victoryFlags": [
      "goldenfields_raid_repelled"
    ],
    "defeatFlags": [
      "goldenfields_raid_lost"
    ],
    "lootMoney": 25,
    "allowRetreat": true,
    "retreatFlags": [
      "goldenfields_destroyed"
    ]
  },
  {
    "id": "ironwatch_siege_battle",
    "commandPointReward": 25,
    "scale": 8,
    "name": "The Siege of Ironwatch",
    "locationId": "ironwatch_fortress",
    "briefing": "The orcs have brought numbers this time. The garrison will hold the gate as long as you hold the yard.",
    "enemyStacks": [
      {
        "unitId": "orc_raiders",
        "count": 21
      },
      {
        "unitId": "orc_berserkers",
        "count": 8
      }
    ],
    "alliedStacks": [
      {
        "unitId": "kingdom_infantry",
        "count": 20
      }
    ],
    "victoryFlags": [
      "ironwatch_siege_repelled",
      "ironwatch_fortress_defended"
    ],
    "defeatFlags": [
      "ironwatch_siege_lost"
    ],
    "lootMoney": 60,
    "reinforcements": [
      {
        "round": 4,
        "side": "friendly",
        "stacks": [
          {
            "unitId": "kingdom_infantry",
            "count": 8
          }
        ],
        "announcement": "The postern gate opens — the reserve watch comes out at a run to join the line."
      }
    ],
    "objectives": [
      {
        "id": "ironwatch_hold_the_yard",
        "description": "Hold the yard: win with the garrison infantry still standing.",
        "kind": "protect_ally",
        "unitId": "kingdom_infantry",
        "rewardFlags": [
          "ironwatch_garrison_intact"
        ],
        "rewardMoney": 40
      }
    ]
  },
  {
    "id": "ironwatch_retake_battle",
    "commandPointReward": 30,
    "scale": 8,
    "name": "The Retaking of Ironwatch",
    "locationId": "ironwatch_fortress",
    "briefing": "Orc banners hang from Ironwatch's walls and the gate is theirs. There is no garrison left to open it for you — only the army at your back. Take the yard and the fortress is the kingdom's again.",
    "enemyStacks": [
      {
        "unitId": "orc_raiders",
        "count": 30
      },
      {
        "unitId": "orc_berserkers",
        "count": 12
      }
    ],
    "alliedStacks": [],
    "victoryFlags": [
      "ironwatch_fortress_retaken",
      "ironwatch_fortress_controlled_by_player"
    ],
    "defeatFlags": [
      "ironwatch_retake_failed"
    ],
    "lootMoney": 50,
    "reinforcements": [
      {
        "round": 3,
        "side": "enemy",
        "stacks": [
          {
            "unitId": "orc_berserkers",
            "count": 4
          }
        ],
        "announcement": "The occupiers were not all on the wall — a second warband boils up out of the inner keep."
      }
    ]
  },
  {
    "id": "ironwatch_advanced_test",
    "name": "Trial by Blade: Three Soldiers",
    "locationId": "ironwatch_fortress",
    "enemyStacks": [
      {
        "unitId": "kingdom_infantry",
        "count": 3
      }
    ],
    "alliedStacks": [
      {
        "unitId": "trainee_duelist",
        "count": 1
      }
    ],
    "victoryFlags": [
      "swordsmanship_advanced_test_won"
    ],
    "defeatFlags": [
      "swordsmanship_advanced_test_failed"
    ],
    "nonLethal": true
  },
  {
    "id": "ironwatch_master_test",
    "name": "Trial by Blade: The Ironwatch Champion",
    "locationId": "ironwatch_fortress",
    "enemyStacks": [
      {
        "unitId": "ironwatch_champion",
        "count": 1
      }
    ],
    "alliedStacks": [
      {
        "unitId": "veteran_duelist",
        "count": 1
      }
    ],
    "victoryFlags": [
      "swordsmanship_master_test_won"
    ],
    "defeatFlags": [
      "swordsmanship_master_test_failed"
    ],
    "nonLethal": true
  },
  {
    "id": "ironwatch_dragon_raid_battle",
    "commandPointReward": 30,
    "scale": 8,
    "name": "The Dragon Over Ironwatch",
    "locationId": "ironwatch_fortress",
    "briefing": "It came down out of the cloud line and it is armoured against everything the fortress can throw. Scale turns steel; fire does nothing to a thing made of fire. Massed archery is the only answer anyone has ever found — the High Elves have been training for exactly this for centuries.",
    "enemyStacks": [
      {
        "unitId": "young_dragon",
        "count": 1
      }
    ],
    "alliedStacks": [
      {
        "unitId": "kingdom_infantry",
        "count": 12
      }
    ],
    "victoryFlags": [
      "ironwatch_dragon_driven_off",
      "faced_a_dragon"
    ],
    "defeatFlags": [
      "ironwatch_dragon_burned_fortress"
    ],
    "lootMoney": 120,
    "allowRetreat": true,
    "retreatFlags": [
      "ironwatch_dragon_burned_fortress"
    ],
    "objectives": [
      {
        "id": "dragon_swift_kill",
        "description": "Bring it down within six rounds, before it fires the granaries.",
        "kind": "win_within_rounds",
        "rounds": 6,
        "rewardFlags": [
          "ironwatch_granaries_saved"
        ],
        "rewardMoney": 80
      }
    ]
  },
  {
    "id": "goldenfields_troll_incursion_battle",
    "commandPointReward": 30,
    "scale": 8,
    "name": "The Trolls in the Goldenfields",
    "locationId": "goldenfields",
    "briefing": "They came up out of the Mire and they do not stay wounded. Cut one open and watch it close again. Fire is the only thing that makes a wound permanent — the Flame Guard exist for this.",
    "enemyStacks": [
      {
        "unitId": "cave_troll",
        "count": 4
      }
    ],
    "alliedStacks": [
      {
        "unitId": "kingdom_infantry",
        "count": 10
      }
    ],
    "victoryFlags": [
      "goldenfields_trolls_driven_off",
      "faced_trolls"
    ],
    "defeatFlags": [
      "goldenfields_destroyed"
    ],
    "lootMoney": 70,
    "allowRetreat": true,
    "retreatFlags": [
      "goldenfields_destroyed"
    ],
    "objectives": [
      {
        "id": "trolls_no_losses",
        "description": "Finish with every stack you brought still standing.",
        "kind": "no_stack_lost",
        "rewardFlags": [
          "goldenfields_harvest_saved"
        ],
        "rewardMoney": 50
      }
    ]
  },
  {
    "id": "rivergate_night_raid_battle",
    "commandPointReward": 40,
    "scale": 8,
    "name": "The Night Raid on Rivergate",
    "locationId": "rivergate",
    "briefing": "Something is killing dockworkers and no one has seen it. Dark Elves do not stand and fight — they shoot from cover and stay in it, and you cannot swing at what you cannot find. Wood Elf Pathfinders can read the ground and call out every hidden position.",
    "enemyStacks": [
      {
        "unitId": "dark_elf_stalkers",
        "count": 14
      }
    ],
    "alliedStacks": [
      {
        "unitId": "human_crossbowmen",
        "count": 10
      }
    ],
    "victoryFlags": [
      "rivergate_raid_broken",
      "faced_dark_elves"
    ],
    "defeatFlags": [
      "rivergate_docks_lost"
    ],
    "lootMoney": 65,
    "allowRetreat": true,
    "retreatFlags": [
      "rivergate_docks_lost"
    ],
    "objectives": [
      {
        "id": "dark_elves_wiped_out",
        "description": "Leave none of the stalkers alive to report back.",
        "kind": "destroy_unit",
        "unitId": "dark_elf_stalkers",
        "rewardFlags": [
          "nightweb_scouting_party_lost"
        ],
        "rewardMoney": 55
      }
    ]
  },
  {
    "id": "temple_anchor_battle",
    "commandPointReward": 40,
    "scale": 8,
    "name": "The Anchor Beneath the Temple",
    "locationId": "ruined_temple_first_dawn",
    "briefing": "A bound stone under the old floor is holding the dead upright, and it will keep raising them for as long as it stands. Steel scratches it. Ritual Mages unmake bindings, and Spirit Wardens contest the dead directly — bring both, or bring a long afternoon.",
    "enemyStacks": [
      {
        "unitId": "necromantic_anchor",
        "count": 1
      },
      {
        "unitId": "skeletal_legion",
        "count": 30
      },
      {
        "unitId": "wraith",
        "count": 4
      }
    ],
    "victoryFlags": [
      "temple_anchor_broken",
      "faced_the_undead"
    ],
    "defeatFlags": [
      "temple_anchor_stands"
    ],
    "lootMoney": 90,
    "allowRetreat": true,
    "retreatFlags": [
      "temple_anchor_stands"
    ],
    "reinforcements": [
      {
        "round": 3,
        "side": "enemy",
        "stacks": [
          {
            "unitId": "skeletal_legion",
            "count": 15
          }
        ],
        "announcement": "The floor splits again. The anchor is still working — more of them are coming up out of it."
      }
    ],
    "objectives": [
      {
        "id": "anchor_destroyed",
        "description": "Break the anchor itself, not merely what it raised.",
        "kind": "destroy_unit",
        "unitId": "necromantic_anchor",
        "rewardFlags": [
          "temple_anchor_unmade"
        ],
        "rewardMoney": 100
      }
    ]
  },
  {
    "id": "crossroads_giant_warband_battle",
    "commandPointReward": 45,
    "scale": 8,
    "name": "The Giants on the King's Road",
    "locationId": "kings_road_crossroads",
    "briefing": "Hill Giants have come down onto the road and there is no way around them. They are armoured in sheer size and have never had to learn caution. Dwarves have fought them in the mountains since before the kingdom existed, and know exactly where a giant's knee is.",
    "enemyStacks": [
      {
        "unitId": "hill_giant",
        "count": 3
      },
      {
        "unitId": "orc_raiders",
        "count": 12
      }
    ],
    "victoryFlags": [
      "kings_road_reopened",
      "faced_giants"
    ],
    "defeatFlags": [
      "kings_road_closed"
    ],
    "lootMoney": 85,
    "allowRetreat": true,
    "retreatFlags": [
      "kings_road_closed"
    ],
    "objectives": [
      {
        "id": "giants_destroyed",
        "description": "Put down every giant — the orcs will scatter without them.",
        "kind": "destroy_unit",
        "unitId": "hill_giant",
        "rewardFlags": [
          "colossus_vale_warband_broken"
        ],
        "rewardMoney": 60
      }
    ]
  },
  {
    "id": "blacktooth_rift_battle",
    "commandPointReward": 40,
    "scale": 8,
    "name": "The Rift in the Blacktooth Wastes",
    "locationId": "blacktooth_wastes",
    "briefing": "The orcs have opened something they cannot close, and it is feeding them. Killing what comes through means nothing while the tear remains — Ritual Mages unmake the binding itself, and Spirit Wardens hold the ground while they work.",
    "enemyStacks": [
      {
        "unitId": "necromantic_anchor",
        "count": 1
      },
      {
        "unitId": "rift_spawn",
        "count": 14
      },
      {
        "unitId": "orc_berserkers",
        "count": 14
      }
    ],
    "victoryFlags": [
      "blacktooth_rift_closed",
      "faced_demon_spirits"
    ],
    "defeatFlags": [
      "blacktooth_rift_widened"
    ],
    "lootMoney": 130,
    "allowRetreat": true,
    "retreatFlags": [
      "blacktooth_rift_widened"
    ],
    "reinforcements": [
      {
        "round": 5,
        "side": "enemy",
        "stacks": [
          {
            "unitId": "rift_spawn",
            "count": 6
          }
        ],
        "announcement": "The tear pulses wider. More of them come through."
      }
    ],
    "objectives": [
      {
        "id": "rift_anchor_destroyed",
        "description": "Close the tear at its anchor, not one spawn at a time.",
        "kind": "destroy_unit",
        "unitId": "necromantic_anchor",
        "rewardFlags": [
          "shattered_veil_denied"
        ],
        "rewardMoney": 120
      },
      {
        "id": "rift_swift",
        "description": "Close it within eight rounds, before the second wave matters.",
        "kind": "win_within_rounds",
        "rounds": 8,
        "rewardMoney": 60
      }
    ]
  },
  {
    "id": "anti_player_assassination_battle",
    "commandPointReward": 15,
    "scale": 6,
    "name": "The Knife in the Doorway",
    "locationId": "dawnmere",
    "briefing": "Hired men, and not many of them. They are not here to win a battle — they are here to make sure one particular person does not walk out of this street. Whoever paid them knew where you would be standing today.",
    "enemyStacks": [
      {
        "unitId": "vane_cutthroats",
        "count": 1
      }
    ],
    "victoryFlags": [
      "anti_player_move_foiled",
      "faced_anti_player"
    ],
    "defeatFlags": [
      "anti_player_move_succeeded"
    ],
    "lootMoney": 30,
    "allowRetreat": true,
    "retreatFlags": [
      "anti_player_move_evaded"
    ],
    "alliedStacks": [
      {
        "unitId": "the_chosen",
        "count": 1
      }
    ]
  },
  {
    "id": "anti_player_ambush_battle",
    "commandPointReward": 15,
    "scale": 5,
    "name": "The Ditch on the King's Road",
    "locationId": "kings_road_crossroads",
    "briefing": "They picked this ground and they have been lying in it since before light, because they knew which road you take. They cannot be targeted until something finds them — Wood Elf Pathfinders are the only scouts who reliably can.",
    "enemyStacks": [
      {
        "unitId": "vane_ambushers",
        "count": 10
      },
      {
        "unitId": "vane_cutthroats",
        "count": 8
      }
    ],
    "victoryFlags": [
      "anti_player_move_foiled",
      "faced_anti_player"
    ],
    "defeatFlags": [
      "anti_player_move_succeeded"
    ],
    "lootMoney": 60,
    "allowRetreat": true,
    "retreatFlags": [
      "anti_player_move_evaded"
    ],
    "objectives": [
      {
        "id": "ambush_broken_clean",
        "description": "Break the ambush without losing a stack — bring someone who can find them first.",
        "kind": "no_stack_lost",
        "rewardFlags": [
          "anti_player_ambush_broken_clean"
        ],
        "rewardMoney": 60
      }
    ],
    "alliedStacks": [
      {
        "unitId": "the_chosen",
        "count": 1
      }
    ]
  },
  {
    "id": "anti_player_training_strike_battle",
    "commandPointReward": 20,
    "scale": 5,
    "name": "Blood in the Practice Yard",
    "locationId": "ironwatch_fortress",
    "briefing": "They came for the teacher, not for you. If the yard is not held, whoever was going to train you here today does not survive the morning.",
    "enemyStacks": [
      {
        "unitId": "vane_cutthroats",
        "count": 10
      },
      {
        "unitId": "vane_ambushers",
        "count": 6
      }
    ],
    "alliedStacks": [
      {
        "unitId": "the_chosen",
        "count": 1
      },
      {
        "unitId": "kingdom_infantry",
        "count": 6
      }
    ],
    "victoryFlags": [
      "anti_player_move_foiled",
      "faced_anti_player"
    ],
    "defeatFlags": [
      "anti_player_move_succeeded",
      "ironwatch_swordmaster_dead",
      "anti_player_killed_a_teacher"
    ],
    "lootMoney": 70,
    "allowRetreat": true,
    "retreatFlags": [
      "anti_player_move_evaded",
      "ironwatch_swordmaster_dead",
      "anti_player_killed_a_teacher"
    ],
    "objectives": [
      {
        "id": "swordmaster_lives",
        "description": "The swordmaster must be standing at the end of it.",
        "kind": "protect_ally",
        "unitId": "kingdom_infantry",
        "rewardFlags": [
          "ironwatch_swordmaster_saved"
        ],
        "rewardMoney": 50
      }
    ]
  },
  {
    "id": "anti_player_court_battle",
    "commandPointReward": 30,
    "scale": 5,
    "name": "The Antechamber at Crownreach",
    "locationId": "crownreach",
    "briefing": "He knows which door the Chamberlain uses and which hour he uses it. Killing the man who arranges audiences closes the court to you for the rest of this loop.",
    "enemyStacks": [
      {
        "unitId": "vane_ambushers",
        "count": 10
      },
      {
        "unitId": "vane_cutthroats",
        "count": 10
      }
    ],
    "alliedStacks": [
      {
        "unitId": "the_chosen",
        "count": 1
      },
      {
        "unitId": "kingdom_infantry",
        "count": 8
      }
    ],
    "victoryFlags": [
      "anti_player_move_foiled",
      "faced_anti_player",
      "crownreach_chamberlain_saved"
    ],
    "defeatFlags": [
      "anti_player_move_succeeded",
      "crownreach_chamberlain_dead",
      "anti_player_killed_a_teacher"
    ],
    "lootMoney": 90,
    "allowRetreat": true,
    "retreatFlags": [
      "anti_player_move_evaded",
      "crownreach_chamberlain_dead",
      "anti_player_killed_a_teacher"
    ]
  },
  {
    "id": "anti_player_sabotage_battle",
    "commandPointReward": 40,
    "scale": 5,
    "name": "The Forger's Table",
    "locationId": "starbow_academy",
    "briefing": "The letters are already written, in your hand, and they are good. Burn the table they were written on before they reach the court that was going to believe them.",
    "enemyStacks": [
      {
        "unitId": "vane_ambushers",
        "count": 12
      },
      {
        "unitId": "vane_turncoats",
        "count": 10
      }
    ],
    "victoryFlags": [
      "anti_player_move_foiled",
      "faced_anti_player"
    ],
    "defeatFlags": [
      "anti_player_move_succeeded",
      "anti_player_sabotaged_an_alliance"
    ],
    "lootMoney": 100,
    "allowRetreat": true,
    "retreatFlags": [
      "anti_player_move_evaded",
      "anti_player_sabotaged_an_alliance"
    ],
    "alliedStacks": [
      {
        "unitId": "the_chosen",
        "count": 1
      }
    ]
  },
  {
    "id": "anti_player_infiltration_battle",
    "commandPointReward": 40,
    "scale": 5,
    "name": "Orders in Your Name",
    "locationId": "ironwatch_fortress",
    "briefing": "Your own soldiers, drawn up in your own colours, marching on orders they believe came from you. They are not traitors. They are simply obeying the wrong man, and they will not stop until somebody makes them.",
    "enemyStacks": [
      {
        "unitId": "vane_turncoats",
        "count": 20
      },
      {
        "unitId": "vane_cutthroats",
        "count": 10
      }
    ],
    "victoryFlags": [
      "anti_player_move_foiled",
      "faced_anti_player"
    ],
    "defeatFlags": [
      "anti_player_move_succeeded",
      "anti_player_turned_a_garrison"
    ],
    "lootMoney": 110,
    "allowRetreat": true,
    "retreatFlags": [
      "anti_player_move_evaded",
      "anti_player_turned_a_garrison"
    ],
    "alliedStacks": [
      {
        "unitId": "the_chosen",
        "count": 1
      }
    ]
  },
  {
    "id": "anti_player_duel_battle",
    "commandPointReward": 50,
    "name": "Aldric Vane",
    "locationId": "kings_road_crossroads",
    "briefing": "No hirelings this time, and no pretence. He has fought you before — more times than you have fought him — and he has had every one of those lifetimes to stop making mistakes. Master-level swordsmanship is not an advantage here; it is the price of admission.",
    "enemyStacks": [
      {
        "unitId": "aldric_vane",
        "count": 1
      }
    ],
    "victoryFlags": [
      "anti_player_move_foiled",
      "faced_anti_player",
      "anti_player_beaten_in_duel"
    ],
    "defeatFlags": [
      "anti_player_move_succeeded"
    ],
    "lootMoney": 150,
    "allowRetreat": true,
    "retreatFlags": [
      "anti_player_move_evaded"
    ],
    "alliedStacks": [
      {
        "unitId": "the_chosen",
        "count": 1
      }
    ]
  },
  {
    "id": "anti_player_final_battle",
    "commandPointReward": 60,
    "scale": 5,
    "name": "The Reckoning at the Temple",
    "locationId": "ruined_temple_first_dawn",
    "briefing": "He is sitting on the steps waiting for you, and he will not draw first. You can end this with a sword. It has been ended with a sword before, and the next morning he was alive in Dawnmere with everything he knows intact.",
    "enemyStacks": [
      {
        "unitId": "aldric_vane",
        "count": 1
      },
      {
        "unitId": "vane_turncoats",
        "count": 12
      }
    ],
    "victoryFlags": [
      "anti_player_move_foiled",
      "faced_anti_player",
      "anti_player_killed_at_temple"
    ],
    "defeatFlags": [
      "anti_player_move_succeeded"
    ],
    "lootMoney": 180,
    "allowRetreat": true,
    "retreatFlags": [
      "anti_player_move_evaded"
    ],
    "alliedStacks": [
      {
        "unitId": "the_chosen",
        "count": 1
      }
    ]
  },
  {
    "id": "blacktooth_stronghold_battle",
    "commandPointReward": 50,
    "scale": 15,
    "name": "The Blacktooth Muster",
    "locationId": "blacktooth_wastes",
    "briefing": "The whole war-camp, not a raiding party. Orcs are only dangerous while they believe they are winning — hit them hard and early and the muster comes apart on its own. Bring numbers and momentum.",
    "enemyStacks": [
      { "unitId": "orc_raiders", "count": 40 },
      { "unitId": "orc_berserkers", "count": 20 },
      { "unitId": "orc_wolf_riders", "count": 15 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["orcs_stronghold_cleared"],
    "defeatFlags": ["blacktooth_muster_marched"],
    "lootMoney": 120,
    "allowRetreat": true,
    "retreatFlags": ["blacktooth_muster_marched"],
    "objectives": [
      {
        "id": "orcs_broken_fast",
        "description": "Break them within seven rounds, before their nerve recovers.",
        "kind": "win_within_rounds",
        "rounds": 7,
        "rewardFlags": ["blacktooth_warchief_broken"],
        "rewardMoney": 70
      }
    ]
  },
  {
    "id": "colossus_vale_battle",
    "commandPointReward": 60,
    "scale": 15,
    "name": "The Warband in Colossus Vale",
    "locationId": "colossus_vale",
    "briefing": "Jarnsmiter's warband, armoured in sheer size and never having needed caution. Steel skids off them and reaching them is the whole problem. Dwarves have fought giants at the knees since before the kingdom — bring Shieldbearers, Hammerguard and the Cannoneers.",
    "enemyStacks": [
      { "unitId": "hill_giant", "count": 5 },
      { "unitId": "frost_giant", "count": 4 },
      { "unitId": "giant_earthshaker", "count": 2 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["giants_stronghold_cleared"],
    "defeatFlags": ["colossus_vale_holds"],
    "lootMoney": 160,
    "allowRetreat": true,
    "retreatFlags": ["colossus_vale_holds"],
    "objectives": [
      {
        "id": "giants_no_losses",
        "description": "Finish with every stack you brought still standing — a properly dwarf-led assault should.",
        "kind": "no_stack_lost",
        "rewardFlags": ["colossus_vale_broken_clean"],
        "rewardMoney": 90
      }
    ]
  },
  {
    "id": "cinderpeak_battle",
    "commandPointReward": 60,
    "scale": 15,
    "name": "The Ember of Cinderpeak",
    "locationId": "cinderpeak",
    "briefing": "Vharethyx itself, and its brood. Scale turns steel and fire means nothing to fire — only massed archery has ever answered a dragon. High Elf Archers, Wood Elf Longbows, Storm Callers; anything else pays in whole stacks.",
    "enemyStacks": [
      { "unitId": "elder_dragon", "count": 1 },
      { "unitId": "young_dragon", "count": 3 },
      { "unitId": "drake_swarm", "count": 10 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["dragons_stronghold_cleared"],
    "defeatFlags": ["cinderpeak_holds"],
    "lootMoney": 220,
    "allowRetreat": true,
    "retreatFlags": ["cinderpeak_holds"],
    "objectives": [
      {
        "id": "dragons_swift",
        "description": "Bring the Ember down within nine rounds, before it can circle and burn.",
        "kind": "win_within_rounds",
        "rounds": 9,
        "rewardMoney": 100
      }
    ]
  },
  {
    "id": "mire_hunger_battle",
    "commandPointReward": 60,
    "scale": 15,
    "name": "The Mother of the Mire",
    "locationId": "mire_hunger",
    "briefing": "Trolls, and they do not stay wounded. Cut one open and watch it close. Fire is the only thing that makes a wound permanent — bring the Flame Guard, or bring a very long afternoon.",
    "enemyStacks": [
      { "unitId": "cave_troll", "count": 8 },
      { "unitId": "mire_troll", "count": 5 },
      { "unitId": "troll_hurler", "count": 6 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["trolls_stronghold_cleared"],
    "defeatFlags": ["mire_hunger_holds"],
    "lootMoney": 150,
    "allowRetreat": true,
    "retreatFlags": ["mire_hunger_holds"],
    "objectives": [
      {
        "id": "trolls_burned_out",
        "description": "Finish inside eight rounds — without fire, you will not.",
        "kind": "win_within_rounds",
        "rounds": 8,
        "rewardMoney": 80
      }
    ]
  },
  {
    "id": "ashen_necropolis_battle",
    "commandPointReward": 70,
    "scale": 15,
    "name": "The Anchor of the Ashen Ground",
    "locationId": "ashen_necropolis",
    "briefing": "A whole city of standing dead, held upright by a great anchor. Steel scratches them; holy force and the unmaking of the anchor lay them down. Spirit Wardens, the Radiant Seraph, Ritual Mages — and break the anchor, not the bodies.",
    "enemyStacks": [
      { "unitId": "necromantic_anchor", "count": 1 },
      { "unitId": "skeletal_legion", "count": 40 },
      { "unitId": "wraith", "count": 8 },
      { "unitId": "death_knights", "count": 6 },
      { "unitId": "bone_colossus", "count": 2 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["undead_stronghold_cleared"],
    "defeatFlags": ["ashen_necropolis_holds"],
    "lootMoney": 180,
    "allowRetreat": true,
    "retreatFlags": ["ashen_necropolis_holds"],
    "reinforcements": [
      {
        "round": 4,
        "side": "enemy",
        "stacks": [{ "unitId": "skeletal_legion", "count": 20 }],
        "announcement": "The ground splits along an old grave-line. The anchor is still working — more of them come up."
      }
    ],
    "objectives": [
      {
        "id": "necropolis_anchor_thrown_down",
        "description": "Throw down the great anchor itself — the dead it holds up will fall with it.",
        "kind": "destroy_unit",
        "unitId": "necromantic_anchor",
        "rewardFlags": ["ashen_anchor_unmade"],
        "rewardMoney": 120
      }
    ]
  },
  {
    "id": "nightweb_battle",
    "commandPointReward": 70,
    "scale": 15,
    "name": "The Nightweb Uncovered",
    "locationId": "nightweb_underrealm",
    "briefing": "The Matron's killers fight only from concealment, and you cannot swing at what you cannot find. Wood Elf Pathfinders, Nomad Outriders, Ancestor Shades — bring something that reveals, or the fight is one-sided in the dark.",
    "enemyStacks": [
      { "unitId": "dark_elf_stalkers", "count": 20 },
      { "unitId": "dark_elf_webcasters", "count": 12 },
      { "unitId": "dark_elf_assassins", "count": 6 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["dark_elves_stronghold_cleared"],
    "defeatFlags": ["nightweb_holds"],
    "lootMoney": 170,
    "allowRetreat": true,
    "retreatFlags": ["nightweb_holds"],
    "objectives": [
      {
        "id": "nightweb_dragged_into_light",
        "description": "Leave none of the assassins alive to slip back into the dark.",
        "kind": "destroy_unit",
        "unitId": "dark_elf_assassins",
        "rewardFlags": ["nightweb_matron_exposed"],
        "rewardMoney": 90
      }
    ]
  },
  {
    "id": "shattered_veil_battle",
    "commandPointReward": 80,
    "scale": 15,
    "name": "The Sealing of the Veil",
    "locationId": "shattered_veil",
    "briefing": "Do not try to outlast the endless. The tear has an anchor holding it open; unmake that and there is nothing left to fight. Ritual Mages and the Radiant Seraph on the anchor, Spirit Wardens holding the ground — break the binding, not the swarm.",
    "enemyStacks": [
      { "unitId": "necromantic_anchor", "count": 1 },
      { "unitId": "rift_spawn", "count": 20 },
      { "unitId": "hellhound_pack", "count": 8 },
      { "unitId": "veil_horror", "count": 3 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["demon_spirits_stronghold_cleared"],
    "defeatFlags": ["shattered_veil_holds"],
    "lootMoney": 220,
    "allowRetreat": true,
    "retreatFlags": ["shattered_veil_holds"],
    "reinforcements": [
      {
        "round": 5,
        "side": "enemy",
        "stacks": [{ "unitId": "rift_spawn", "count": 10 }],
        "announcement": "The tear pulses wider. More of them pour through while it stands."
      }
    ],
    "objectives": [
      {
        "id": "veil_sealed_at_anchor",
        "description": "Close the tear at its anchor — not one spawn at a time.",
        "kind": "destroy_unit",
        "unitId": "necromantic_anchor",
        "rewardFlags": ["shattered_veil_sealed"],
        "rewardMoney": 130
      }
    ]
  },
  {
    "id": "ebon_citadel_battle",
    "commandPointReward": 100,
    "scale": 20,
    "name": "The Necromancer of the Ebon Citadel",
    "locationId": "ebon_citadel",
    "briefing": "The ritual chamber, the man at the centre of it, and every champion he has kept and killed and kept again drawn up around him. He is warded against steel, arrows and fire alike — five hundred days of weaving. He is himself an anchor: only holy force and the unmaking of bindings reach him. Put the Radiant Seraph, Spirit Wardens and Ritual Mages onto the Necromancer; hold everything else off them while they work. And be quick — do not fight the dead he raises, reach the hand that raises them, because the sky outside is nearly out.",
    "enemyStacks": [
      { "unitId": "the_necromancer", "count": 1 },
      { "unitId": "death_knights", "count": 8 },
      { "unitId": "bone_colossus", "count": 2 },
      { "unitId": "wraith", "count": 10 },
      { "unitId": "veil_horror", "count": 2 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["necromancer_defeated", "sun_saved"],
    "defeatFlags": ["ebon_citadel_assault_failed"],
    "allowRetreat": true,
    "retreatFlags": ["ebon_citadel_assault_failed"],
    "reinforcements": [
      {
        "round": 4,
        "side": "enemy",
        "stacks": [{ "unitId": "skeletal_legion", "count": 24 }],
        "announcement": "The Necromancer lifts a hand and the floor gives up another rank of the dead. He will do this for as long as he stands — so do not fight the dead. Reach him."
      }
    ],
    "objectives": [
      {
        "id": "necromancer_thrown_down",
        "description": "Throw down the Necromancer himself — the dead he raises fall with him.",
        "kind": "destroy_unit",
        "unitId": "the_necromancer"
      },
      {
        "id": "sun_saved_with_time",
        "description": "End it within ten rounds, before the ritual completes above you.",
        "kind": "win_within_rounds",
        "rounds": 10,
        "rewardFlags": ["sun_saved_with_margin"]
      }
    ]
  },
  {
    "id": "accusation_humans_battle",
    "scale": 8,
    "name": "The Crown's Guard",
    "locationId": "crownreach",
    "briefing": "You said the wrong thing under the forged letters and the Chamberlain has called the household guard. These are the Crown's own — kingdom spears and the knights of the presence chamber — and they believe you are exactly what the paper says. Cut clear if you can. If you cannot, they hang traitors from the Crownreach gate.",
    "enemyStacks": [
      { "unitId": "kingdom_infantry", "count": 12 },
      { "unitId": "kingdom_knights", "count": 8 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["accusation_faced_humans", "accusation_cut_free_humans"],
    "defeatFlags": ["executed_by_accusation", "hanged_by_humans"],
    "allowRetreat": true,
    "retreatFlags": ["accusation_faced_humans", "accusation_cut_free_humans"]
  },
  {
    "id": "accusation_high_elves_battle",
    "scale": 8,
    "name": "The Moonspire Court's Wrath",
    "locationId": "moonspire",
    "briefing": "The Court has heard enough. The letters are in your hand and your last answer sealed them. Lancers and archers of the presence move to take you, and an elven court does not imprison a traitor — it reads the sentence and carries it out the same hour. Fight free or be hanged in the Moonspire dark.",
    "enemyStacks": [
      { "unitId": "high_elf_lancers", "count": 10 },
      { "unitId": "high_elf_archers", "count": 12 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["accusation_faced_high_elves", "accusation_cut_free_high_elves"],
    "defeatFlags": ["executed_by_accusation", "hanged_by_high_elves"],
    "allowRetreat": true,
    "retreatFlags": ["accusation_faced_high_elves", "accusation_cut_free_high_elves"]
  },
  {
    "id": "accusation_dwarves_battle",
    "scale": 8,
    "name": "Thane Durn's Hearthguard",
    "locationId": "stonehall",
    "briefing": "Durn does not shout. He simply nods, and the hearthguard of Stonehall lower their shields and come on — shieldbearers and hammerguard who have held these halls against giants and will not be lied to under their own roof. A dwarf hangs an oathbreaker from the gate-beam. Cut your way out, or swing.",
    "enemyStacks": [
      { "unitId": "dwarven_shieldbearers", "count": 12 },
      { "unitId": "dwarven_hammerguard", "count": 10 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["accusation_faced_dwarves", "accusation_cut_free_dwarves"],
    "defeatFlags": ["executed_by_accusation", "hanged_by_dwarves"],
    "allowRetreat": true,
    "retreatFlags": ["accusation_faced_dwarves", "accusation_cut_free_dwarves"]
  },
  {
    "id": "accusation_wood_elves_battle",
    "scale": 8,
    "name": "Sylvaine's Rangers",
    "locationId": "greenveil",
    "briefing": "Warden Sylvaine gives the sign and Greenveil answers from the branches — thornguard closing the ring, longbows already drawn. They tracked Dark Elves through this wood; you will not slip them. The rangers hang a traitor where the whole grove can see. Break out, or do not.",
    "enemyStacks": [
      { "unitId": "wood_elf_thornguard", "count": 11 },
      { "unitId": "wood_elf_longbows", "count": 12 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["accusation_faced_wood_elves", "accusation_cut_free_wood_elves"],
    "defeatFlags": ["executed_by_accusation", "hanged_by_wood_elves"],
    "allowRetreat": true,
    "retreatFlags": ["accusation_faced_wood_elves", "accusation_cut_free_wood_elves"]
  },
  {
    "id": "accusation_spellcasters_battle",
    "scale": 8,
    "name": "The Tower's Answer",
    "locationId": "sevenfold_tower",
    "briefing": "Vaeloth closes the book of your letters and the wards of the Sevenfold Tower turn inward. Flame guard and storm callers take the stairs above and below you at once. The orders do not keep prisoners who might be the Necromancer's ear — they unmake them. Force the door, or burn.",
    "enemyStacks": [
      { "unitId": "flame_guard", "count": 11 },
      { "unitId": "storm_callers", "count": 10 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["accusation_faced_spellcasters", "accusation_cut_free_spellcasters"],
    "defeatFlags": ["executed_by_accusation", "hanged_by_spellcasters"],
    "allowRetreat": true,
    "retreatFlags": ["accusation_faced_spellcasters", "accusation_cut_free_spellcasters"]
  },
  {
    "id": "accusation_good_spirits_battle",
    "scale": 8,
    "name": "The Pale Sister's Sentence",
    "locationId": "whispering_lake",
    "briefing": "The Sister lowers her eyes, which is worse than any shout, and the wardens of the Lake step between you and the water. Spirit wardens and the shades of the Hall move as one thing. They contest the dead; a living liar is a small matter to them. Win clear of the shallows, or be given to them.",
    "enemyStacks": [
      { "unitId": "spirit_wardens", "count": 12 },
      { "unitId": "ancestor_shades", "count": 10 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["accusation_faced_good_spirits", "accusation_cut_free_good_spirits"],
    "defeatFlags": ["executed_by_accusation", "hanged_by_good_spirits"],
    "allowRetreat": true,
    "retreatFlags": ["accusation_faced_good_spirits", "accusation_cut_free_good_spirits"]
  },
  {
    "id": "accusation_nomads_battle",
    "scale": 8,
    "name": "The Banners Turn",
    "locationId": "camp_seven_banners",
    "briefing": "Khan Aytolga spits in the dust and the Seven Banners wheel their horses around you. Lancers and horse archers, and open steppe on every side — there is nowhere on this ground they cannot ride you down. The clans drag an oathbreaker behind a horse and hang what is left. Cut out of the ring, or end in it.",
    "enemyStacks": [
      { "unitId": "nomad_lancers", "count": 11 },
      { "unitId": "nomad_horse_archers", "count": 12 }
    ],
    "alliedStacks": [{ "unitId": "the_chosen", "count": 1 }],
    "victoryFlags": ["accusation_faced_nomads", "accusation_cut_free_nomads"],
    "defeatFlags": ["executed_by_accusation", "hanged_by_nomads"],
    "allowRetreat": true,
    "retreatFlags": ["accusation_faced_nomads", "accusation_cut_free_nomads"]
  }
]
